export default __webpack_public_path__ + "static/media/goverance.256040df.png";